import { useMemo } from "react";

type PaginateProps = {
  totalPages: number;
  page: number;
  to: (page: number) => void;
}
export default function Paginate ({page, totalPages, to}: PaginateProps) {
  const paginationItems: (number|'...')[] =  useMemo(() => buildPagination(totalPages, page), [page, totalPages])

  function buildPagination(totalPages: number, currentPage: number, maxItems = 3) {
    const items = [] as (number|'...')[];

    // Get the start and the end pages
    let startPage = Math.max(1, currentPage - Math.floor(maxItems / 2));
    const endPage = Math.min(totalPages, startPage + maxItems - 1);

    // Ensuring the total number of items displayed remains the same
    if (endPage - startPage + 1 < maxItems) {
      startPage = Math.max(1, endPage - maxItems + 1);
    }
    
    // Add the first element
    if (startPage > 1) {
      items.push(1);
      if (startPage > 2) {
        items.push('...');
      }
    }

    // Add page numbers to the item list
    for (let i = startPage; i <= endPage; i++) {
      items.push(i);
    }

    // Add the last element
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        items.push('...');
      }
      items.push(totalPages);
    }

    return items;
  }

  return (
    <ul className="flex gap-1.5 items-center">
      {
        paginationItems.map((item, i) => (
          <li key={i} className={`${item === '...' ? 'mx-1' : 'size-[40px] rounded-lg grid place-items-center border'}
            ${ item === page ? 'text-white bg-primary border-primary' : item !== '...' ? 'border-izygray hover:text-white hover:bg-primary' : ''}`}
            role={item === '...' || item === page ? 'listitem' : 'button'}
            onClick={() => item !== '...' && item !== page && to(item)} >{item}
          </li>
        ))
      }
    </ul>
  )
}